"use strict";

import {
    default as React,
    Component,
 } from 'react';
import PropTypes from 'prop-types';

import * as D3Selection from 'd3-selection'
import ReactFauxDOM from 'react-faux-dom';
import CommonProps from '../commonProps';

export default class Label extends Component {
    constructor (props) {
        super(props);
    }

    static defaultProps = {
        hTransform: 'rotate(0)',
        vTransform: 'rotate(270)',
        labelTitle: 'label title',
        labelPosition: 'bottom',
        labelOffset: 40,
        textAnchor: 'middle',
        labelClassName: 'react-d3-core__label',
        ...CommonProps
    }

    static propTypes = {
        height: PropTypes.number.isRequired,
        width: PropTypes.number.isRequired,
        margins: PropTypes.object.isRequired,
        labelHShift: PropTypes.number,
        labelVShift: PropTypes.number,
        labelRotate: PropTypes.number,
        labelTitle: PropTypes.string,
        labelPosition: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
        labelOffset: PropTypes.number,
        textAnchor: PropTypes.string,
        labelClassName: PropTypes.string
    }

    _mkLabel(dom) {
        const {
            height,
            width,
            margins,
            labelOffset,
            labelTitle,
            labelPosition,
            labelVShift,
            labelHShift,
            labelRotate,
        } = this.props;

        let labelDom = D3Selection.select(dom);
        let fixWidth = width - margins.left - margins.right;
        let fixHeight = height - margins.top - margins.bottom;

        if(labelHShift){
            labelDom
                .attr('transform', `translate(${labelHShift}, ${0})`)
        }

        if(labelVShift){
            labelDom
                .attr('transform', `translate(${0}, ${labelVShift})`)
        }

        if(labelRotate){
            labelDom
                .attr('transform', `rotate(${labelRotate})`)
        }

        if (labelPosition === 'top') {
            labelDom
                .attr('y', -labelOffset)
                .attr('x', fixWidth / 2)

        }else if (labelPosition === 'bottom') {

            labelDom
                .attr('y', +labelOffset)
                .attr('x', fixWidth / 2)

        }else if (labelPosition === 'left') {

            labelDom
                .attr('y', -labelOffset)
                .attr('x', -fixHeight / 2)

        }else if (labelPosition === 'right') {

            labelDom
                .attr('y', +labelOffset)
                .attr('x', -fixHeight / 2)
        }

        labelDom
            .text(labelTitle);

        return labelDom;
    }

    render() {
        const {
            labelClassName,
            labelCustomStyle,
        } = this.props;

        let labelText = ReactFauxDOM.createElement('text');
        let labelClasses = `${labelClassName} label`;

        labelCustomStyle ? Object.keys(labelCustomStyle).map(function(_) {
            labelText.style(_, labelCustomStyle[_]);
        }) : null;


        labelText.setAttribute('class', labelClasses);

        let labelDom = this._mkLabel(labelText);

        return labelDom.node().toReact();
    }
}
